import { appConfig } from '../config/app.config';

/** Identity app key (`NX_PUBLIC_APP_KEY`). Not the CMS gateway web key. */
export function getGuestIdentityAppKey(): string {
    return process.env.NX_PUBLIC_APP_KEY || '';
}

export function buildGuestPublicConfigUrl(): string {
    const base = appConfig.guestConfigBaseUrl;
    const appKey = getGuestIdentityAppKey();
    if (!base || !appKey) {
        return '';
    }
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}appKey=${encodeURIComponent(appKey)}&client=WEB`;
}

export function buildGuestLoginUrl(): string {
    const base = appConfig.guestLoginBaseUrl;
    const appKey = getGuestIdentityAppKey();
    if (!base || !appKey) {
        return '';
    }
    return `${base.replace(/\/+$/, '')}/${encodeURIComponent(appKey)}/login/guest/user`;
}
